import React from 'react';
import { X } from 'lucide-react';

/* Shared modal + layout primitives for the HR module. */

/* ---------------- Small helpers ---------------- */

function Modal({ children, onClose, wide }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-start justify-center overflow-y-auto py-8 px-4 print:static print:bg-transparent print:p-0" onClick={onClose}>
      <div className={`surface rounded-xl border border-soft shadow-xl w-full ${wide ? 'max-w-3xl' : 'max-w-xl'} p-5 relative print:shadow-none print:border-0 print:max-w-none`} onClick={e => e.stopPropagation()}>
        <button className="absolute top-3 right-3 text-fg-muted hover:text-fg print:hidden" onClick={onClose}><X className="w-5 h-5"/></button>
        {children}
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-4">
      <div className="text-[11px] font-bold uppercase tracking-wider text-fg-muted mb-2 border-b border-soft pb-1">{title}</div>
      {children}
    </div>
  );
}

function L({ label, children, full }) {
  return (
    <label className={`block ${full ? 'mt-3' : ''}`}>
      <div className="text-xs text-fg-muted mb-1">{label}</div>
      {children}
    </label>
  );
}

function Row({ k, v }) {
  if (!v) return null;
  return (<><dt className="text-fg-muted">{k}</dt><dd className="font-medium break-words">{v}</dd></>);
}

export { Modal, Section, L, Row };
